import React from 'react';
import { UserType } from 'types/User.type';
import { NormalResponseError } from 'types/Common.type';

interface AuthContextType {
  user?: UserType;
  loading: boolean;
  error?: NormalResponseError;
  currentUser?: UserType;
  setError?: (payload: any) => void;
  login: (email: string, password: string) => void;
  logout: () => void;
  update: (value: UserType) => void;
  onCurrentUserChanged: (value: UserType) => void;
  getCurrentUserId: () => string;
  getLoginUser: () => void;
  isStripeAccountConnected: () => boolean;
  isStripeAccountCompletedOnboarding: () => boolean;
  isStripeAccountRestricted: () => boolean;
}

const AuthContext = React.createContext<AuthContextType | any>({} as AuthContextType);

export function useAuth() {
  return React.useContext(AuthContext);
}

export default AuthContext;